import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FleetViewComponent } from './fleet-view.component';

@NgModule({
  declarations: [FleetViewComponent],
  imports: [CommonModule],
  exports: [FleetViewComponent],
})
export class FleetViewModule {}
